import { FC } from 'react';

import { PermissionType } from 'api/types/entity';
import { useTranslation } from 'libs/i18n';
import { PermissionWrapper } from 'libs/permissions';
import { Button, Stack } from 'libs/ui';
import { useDialog } from 'libs/ui/Dialog/useDialog';
import { Icon } from 'libs/ui/Icon';
import { AdministrationView as BaseAdministrationView } from 'modules/administration/common/views';

import { AdminsTable, AdminsTableProps } from '../components';
import { CreateAdminDialogFeature } from '../features';

import { SearchBarStyled } from './styles';

export interface AdminsViewProps extends AdminsTableProps {
  search: string;
  onSearch: (v: string) => void;
}

export const AdminsView: FC<AdminsViewProps> = ({
  search,
  onSearch,
  ...tableProps
}) => {
  const { t } = useTranslation();

  const { isOpen, onClose, open } = useDialog();

  return (
    <Stack spacing={12}>
      <BaseAdministrationView
        headerRightContent={
          <Stack direction="row" justifyContent="space-between" spacing={12}>
            <SearchBarStyled search={search} onSearch={onSearch} />
            <PermissionWrapper permissions={[PermissionType.User_CreateOne]}>
              <Button
                fullWidth={false}
                label={t('common.add')}
                sizeVariant="s"
                startIcon={<Icon.Plus size={16} />}
                onClick={open}
              />
            </PermissionWrapper>
          </Stack>
        }
        tabValue="admins"
      >
        <AdminsTable
          noRowsLabel={search ? t('components.table.searchEmptyData') : ''}
          {...tableProps}
        />

        <CreateAdminDialogFeature isOpen={isOpen} onClose={onClose} />
      </BaseAdministrationView>
    </Stack>
  );
};
